import { all, take, put, race, select } from 'redux-saga/effects'
import _ from 'lodash'
import { List } from 'immutable'
import { SUCCESS, FAILED } from 'crom-api-constants'

import IntlSaga from '../../../../../services/translations/intl-saga'

import { createGroupRequest, addGroupToEntityStack, setupGroupStack } from '../actions'

import { currentLocaleSelector } from '../selectors'

import { CREATE_GROUP_REQUEST, LOCALE_PREFIX } from '../constants'

const dataPath = 'response.success.payload.response.body'

export default function* createGroupSaga() {
    const locale = yield select(currentLocaleSelector)
    const groupName = IntlSaga.formatMessage(locale, `${LOCALE_PREFIX}.newGroupName`)

    const result = yield all({
        response: race({
            success: take(`${CREATE_GROUP_REQUEST}_${SUCCESS}`),
            failed: take(`${CREATE_GROUP_REQUEST}_${FAILED}`),
        }),
        request: put(createGroupRequest(groupName)),
    })

    const data = _.get(result, dataPath)

    yield put(addGroupToEntityStack(data))

    const { id: groupId } = data

    yield put(
        setupGroupStack(groupId, {
            page: 0,
            rows: 0,
            pages: 0,
            members: List(),
            loading: false,
        })
    )

    return null
}
